import BaseContent from "./base.content";
import {
  TYPE_TWO_COLUMN_CONTENT,
  DEFAULT_CLUB_HEADER_TWO_LABEL, TYPE_TRANSFERS_CONTENT, TYPE_DETAILS_CONTENT
} from "./constants";
import {HeaderOneContent, HeaderOneContentDTO, HeaderOneContentMapper} from "./headers/header-one.content";
import HeaderTwoContent from "./headers/header-two.content";
import Immutable from "immutable";
// import {ITwoColumnContentRaw} from "./content/two-column.content";
import {CMSContentType} from "./CMSType";
import {List, Record} from 'immutable';
import {factoryCmsContent} from "./content";
import {isDetailsContent} from "./content/mappers/details";
import {DetailsDTO} from "./content/details.content";

const CmsEditorStateRecord = Record({
  items: List<HeaderOneContent>()
});

export type CmsEditorStateDTO = HeaderOneContentDTO[];

const headerOneContentMapper:HeaderOneContentMapper = new HeaderOneContentMapper();

export class CmsEditorState extends CmsEditorStateRecord {
  public readonly items: List<HeaderOneContent>;

  protected _updateItems(items: Immutable.List<HeaderOneContent>): CmsEditorState {
    return new CmsEditorState({ items });
  }

  addHeaderOne(header: HeaderOneContent): CmsEditorState {
    return this._updateItems(this.items.push(header));
  }

  addHeaderOneRaw(data: {label: string; icon: string;}): CmsEditorState {
    return this._updateItems(this.items.push(new HeaderOneContent(data)));
  }

  protected _findHeaderOne(headerTwo: HeaderTwoContent): HeaderOneContent {
    return this.items.find((headerOne) => headerOne.children.contains(headerTwo));
  }

  protected _findHeaderTwoByContent(content: BaseContent): HeaderTwoContent {
    return this.items.map((headerOne) => headerOne.children).flatten()
      .find((headerTwo) =>  {
        return headerTwo.children && headerTwo.children.contains(content)
      });
  }

  public addHeaderContent(type: CMSContentType): CmsEditorState {
    let header = new HeaderOneContent({label: DEFAULT_CLUB_HEADER_TWO_LABEL});
    return this.addHeaderOne(header);
  }

  public updateHeaderOne(oldOne: HeaderOneContent, headerOne: HeaderOneContent): CmsEditorState {
    let index = this.items.indexOf(oldOne);
    return this._updateItems(this.items.set(index, headerOne));
  }

  public updateHeaderTwo(headerTwo: HeaderTwoContent): CmsEditorState {
    let headerOne: HeaderOneContent = this._findHeaderOne(headerTwo);
    return this.updateHeaderOne(headerOne, headerOne.updateListItem(headerTwo, headerTwo));
  }

  public updateContent(content: BaseContent): CmsEditorState {
    return this.updateHeaderTwo(this._findHeaderTwoByContent(content).updateListItem(content, content));
  }

  public removeHeaderOne(headerOne: HeaderOneContent) {
    return this._updateItems(this.items.delete(this.items.indexOf(headerOne)));
  }

  public removeHeaderTwo(headerTwo: HeaderTwoContent) {
    let headerOne: HeaderOneContent = this._findHeaderOne(headerTwo);

    return this.updateHeaderOne(headerOne, headerOne.remove(headerTwo));
  }

  public removeContent(content: BaseContent) {
    let headerTwo = this._findHeaderTwoByContent(content);

    return this.updateHeaderTwo(headerTwo.remove(content));
  }

  public moveItem(headerOneMoved: HeaderOneContent, headerOne: HeaderOneContent) {
    let headerOneMovedIndex = this.items.indexOf(headerOneMoved);
    let headerOneIndex = this.items.indexOf(headerOne);

    return this._updateItems(
      this.items.deleteIn([headerOneMovedIndex])
        .insert(headerOneIndex, headerOneMoved)
    );

  }

  public parse(content: CmsEditorStateDTO): CmsEditorState {
    let items = content.map(headerOneData => this.parseHeaderOne(headerOneData));

    return this._updateItems(Immutable.List<HeaderOneContent>(items));
  }

  public toJSON(): CmsEditorStateDTO {
    return this.items.toArray().map((item) => {
      let data = headerOneContentMapper.toDTO(item);
      data.children = data.children.reduce(
        (prev, item) => prev.concat(item.type === TYPE_DETAILS_CONTENT ? (<DetailsDTO>item).items : [item]),
        []
      );
      return data;
    });
  }

  public move(oldIndex: number, newIndex: number) {
    return this._updateItems(List(this.items.toArray()
      .reduce((prevValue, value, index, base) => {
      if (index !== oldIndex) {

        if (index === newIndex && oldIndex > newIndex) {
          prevValue.push(base[oldIndex]);
        }

        prevValue.push(value);

        if (index === newIndex && oldIndex < newIndex) {
          prevValue.push(base[oldIndex]);
        }
      }

      return prevValue;
    }, [])));
  }


  private parseHeaderOne(data: HeaderOneContentDTO): HeaderOneContent {
    //@todo remove this hack
    data = isDetailsContent(data.children)
      ? Object.assign({}, data, {children: [{type: TYPE_DETAILS_CONTENT, items: data.children}]})
      : data;

    let mapper = new HeaderOneContentMapper();
    return mapper.fromDTO(data);
  }

  private parseHeaderTwo(data: any): HeaderTwoContent {
    return new HeaderTwoContent({ label: data.label, items: data.children.map(
      (contentData: any) => this._parseContent(contentData)
    )});
  }

  private _parseContent(data: any): BaseContent {
    let { type } = data;
    switch (type) {
      case TYPE_TWO_COLUMN_CONTENT:
        // return this.parseTwoColumnsContent(data);
      case TYPE_TRANSFERS_CONTENT:
        // return this.parseTransferContent(data);
      default:
        return factoryCmsContent(type, data);
    }
  }
/*
  private parseTwoColumnsContent(data: ITwoColumnContentRaw) {
    return new TwoColumnContent(
      data.leftLabel,
      data.rightLabel,
      data.items.map((rowData: ITwoColumnContentRowRaw) => {
        let row = new TwoColumnContentItem();
        row.setLeftCell(new TwoColumnContentCell(rowData.leftCell.primaryText));
        row.setRightCell(new TwoColumnContentCell(rowData.rightCell.primaryText));

        return row;
      })
    );
  }
  */
/*
  private parseTransferContent(data: ITwoColumnContentRaw) {
    return new TransferContent(
      data.leftLabel,
      data.rightLabel,
      data.items.map((rowData: ITwoColumnContentRowRaw) => {
        let row = new TransferContentItem();
        row.setLeftCell(new TwoColumnContentCell(rowData.leftCell.primaryText));
        row.setRightCell(new TwoColumnContentClubCell(rowData.rightCell.primaryText, rowData.rightCell.avatar, rowData.rightCell.record_id));

        return row;
      })
    );
  }
  */
}



// WEBPACK FOOTER //
// ./src/api/club-cms/index.ts